module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-logo-7-b17efc71d1966f2d18ebc4da548ce966.png";